import { gql } from "apollo-boost";

// Proveedor (farmacia) del usuario autenticado de farmacia o call center.
export const GET_ACCESS_PROVIDER = gql`
  query accessProvider {
    provider: getPharmacyProviderLogo {
      id
      name
      commercialName
    }
  }
`;

export const getAccessProviderName = (provider) =>
  (provider?.commercialName || provider?.name || "").toString().trim();

// Opciones del menú de configuración para usuarios sin pantallas propias de
// configuración (farmacia, call center y administración): solo seguridad; el
// menú agrega el cierre de sesión.
export const ACCOUNT_CONFIG_ITEMS = [
  { name: "Seguridad", icon: "fa fa-shield", key: "isOpenModalSecurity", value: true },
];
